import service from "@/utils/request";

// 商户信息
export const getMerchantInfoApi = () => {
  return service({
    url: "/api/v1/payment/merchant/info",
    method: "get",
  });
};
// 提现申请
export interface sendWithdrawData {
  sms_code: string;
  draw_amount: string;
}
export const sendWithdrawApi = (data: sendWithdrawData) => {
  return service({
    url: "/api/v1/payment/withdraw/apply",
    method: "post",
    data,
  });
};
// 提现记录
export interface getWithdrawLogData {
  page?: number;
  page_size?: number;
  sort_field?: string;
  sort_type?: string;
  draw_no?: string;
  status?: string;
  complete_time_start?: string;
  complete_time_end?: string;
  create_time_start?: string;
  create_time_end?: string;
  withdrawal_method?: number;
}
export const getWithdrawLogApi = (params: getWithdrawLogData) => {
  return service({
    url: "/api/v1/payment/withdraw/list",
    method: "get",
    params,
  });
};
// 账户余额
export const getAccountBalanceApi = () => {
  return service({
    url: "/api/v1/payment/wallet/balance",
    method: "get",
  });
};
// 收支明细
export interface getBillDetailData {
  page?: number;
  page_size?: number;
  sort_field?: string;
  sort_type?: string;
  log_type?: string;
  biz_code?: string;
  biz_id?: string;
  student_id?: number;
  create_time_start?: number;
  create_time_end?: number;
  trade_time_start?: number;
  trade_time_end?: number;
}
export const getBillDetailApi = (params: getBillDetailData) => {
  return service({
    url: "/api/v1/payment/wallet/bill",
    method: "get",
    params,
  });
};
// 提现记录导出
export interface exportWithdrawLogData {
  sort_field?: string;
  sort_type?: string;
  draw_no?: string;
  status?: number;
  complete_time_start?: number;
  complete_time_end?: number;
  create_time_start?: number;
  create_time_end?: number;
  withdrawal_method?: number;
}
export const exportWithdrawLogApi = (data: exportWithdrawLogData) => {
  return service({
    url: "/api/v1/payment/withdraw/list/export",
    method: "post",
    data,
  });
};
// 收支明细导出
export interface exportBillDetailData {
  sort_field?: string;
  sort_type?: string;
  log_type?: string;
  biz_code?: string;
  biz_id?: string;
  student_id?: number;
  create_time_start?: number;
  create_time_end?: number;
  trade_time_start?: number;
  trade_time_end?: number;
}
export const exportBillDetailApi = (data: exportBillDetailData) => {
  return service({
    url: "/api/v1/payment/wallet/bill/export",
    method: "post",
    data,
  });
};

// 提现配置 - 详细
export const withdrawalInfoApi = () => {
  return service({
    url: "/api/v1/payment/withdraw_config/info",
    method: "get",
  });
};

// 提现配置 - 编辑
export interface withdrawConfigEditData {
  auto_switch?: number;
  auto_time?: string;
  staff_id?: number;
  staff_ids?: number[];
}
export const withdrawConfigEditApi = (data: withdrawConfigEditData) => {
  return service({
    url: "/api/v1/payment/withdraw_config/edit",
    method: "post",
    data,
  });
};

// 在线支付申请
export const applySubmitApi = (data: any) => {
  return service({
    url: "/api/v1/payment/apply/submit",
    method: "post",
    data,
  });
};

// 点击数上报
export const applyClickApi = (data: any) => {
  return service({
    url: "/api/v1/payment/apply/click",
    method: "post",
    data,
  });
};

// 在线支付申请认证状态
export const applyStatusApi = (params: any) => {
  return service({
    url: "/api/v1/payment/apply/status",
    method: "get",
    params,
  });
};

// 文章详情
export const applyDetailApi = (params: any) => {
  return service({
    url: "/api/v1/article/detail",
    method: "get",
    params,
  });
};
